import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import { useEffect, useState } from 'react'
import { ProductPreviewCard } from 'components/card'
import { formatStoreNameToIconName } from 'components/icons'
import { SOURCE_POST_SIGNUP } from 'shared/constants'
import { Bowed } from 'components/curves'
import TrackVisibility from 'react-on-screen'
import { track, withContextualizedTracking } from 'lib/analytics'
import { ConfettiOverlayPrimer } from './ConfettiOverlayPrimer/ConfettiOverlayPrimer'
import { saveOnboardingData, setUserResponse } from '../../actions'
import Slide from '../Slide/Slide'
import css from './mobile-add-items-experience.styles.scss'
import { getPostSignupEcommerce } from '../../api'
import { useNavigate } from 'react-router-dom-v5-compat'

const ProductCard = ({ product, handleQuickAddSuccess }) => {
  const storeOfferIconNames = product.offers.map((o) =>
    formatStoreNameToIconName(o.storeName)
  )
  // Empty string for productUrl because we don't want to link to the product
  return (
    <ProductPreviewCard
      key={product.id}
      imageUrl={product.image.thumbnailUrl}
      productUrl=""
      brand={product.brand}
      name={product.name}
      price={{
        min: product.price.current,
        max: product.price.current,
      }}
      storeOfferIconNames={storeOfferIconNames}
      QuickAddButtonComponent={
        <ProductPreviewCard.QuickAddRegItem
          productOnRegistry={false}
          product={product}
          source={SOURCE_POST_SIGNUP}
          onSuccess={() => {
            handleQuickAddSuccess()
          }}
        />
      }
      __forcePageLoad
    />
  )
}

const ProductCardWithTracking = withContextualizedTracking({
  eventLocation: track.EventLocation.ONBOARDING_MINUS_ADD_WALKTHROUGH,
})(ProductCard)

const sortedPostSignupEcommerce = (postSignupEcommerce) => {
  const order = ['Registry Favorites', 'Try-it Kits', 'First Aid', 'Books']
  return postSignupEcommerce.sort((a, b) => {
    const aIndex = order.indexOf(a.category)
    const bIndex = order.indexOf(b.category)
    return aIndex - bIndex
  })
}

const trackingAttributes = {
  eventLocation: track.EventLocation.ONBOARDING_MINUS_ADD_WALKTHROUGH,
}

const MobileAddItemsExperience = ({ nextPath }) => {
  const [postSignupEcommerce, setPostSignupEcommerce] = useState([])
  const [productAdded, setProductAdded] = useState(false)
  const [showStickyCta, setShowStickyCta] = useState(false)
  const [showConfettiPrimer, setShowConfettiPrimer] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    getPostSignupEcommerce().then((data) => {
      setPostSignupEcommerce(data)
    })
  }, [])

  const handleQuickAddSuccess = () => {
    setProductAdded(true)
  }

  const goToNext = () => {
    track.onboardingQuestionAnswered(trackingAttributes)
    navigate(nextPath)
  }

  if (!postSignupEcommerce.length) return null

  if (showConfettiPrimer) {
    return (
      <Slide className={css.mobile_add_items_experience}>
        <ConfettiOverlayPrimer />
      </Slide>
    )
  }

  return (
    <Slide className={css.mobile_add_items_experience}>
      {sortedPostSignupEcommerce(postSignupEcommerce).map((item) => (
        <div key={item.category}>
          <div className={css.sectionTitle}>{item.title}</div>
          <div className={css.sectionSubtitle}>{item.subtitle}</div>
          <div className={css.sliderLayout}>
            {item.products.slice(0, 4).map((product) => (
              <ProductCardWithTracking
                key={product.id}
                product={product}
                handleQuickAddSuccess={handleQuickAddSuccess}
              />
            ))}
          </div>
        </div>
      ))}
      <Bowed color="#faf6f3" position="top" inverted />
      <div className={css.greatStart__cta}>
        <div className={css.greatStart__ctaContent}>
          <h2 className={css.greatStart__headerText}>Great start!</h2>
          <p className={css.greatStart__ctaSubtitle}>
            Now you&rsquo;re ready to really start prepping for baby.
          </p>
          <TrackVisibility>
            {({ isVisible }) => {
              setShowStickyCta(productAdded && !isVisible)
              return (
                <InfoButton
                  className={css.greatStart__ctaButton}
                  onClick={() => {
                    goToNext()
                  }}
                >
                  I&rsquo;m All Set
                </InfoButton>
              )
            }}
          </TrackVisibility>
        </div>
        <div className={css.greatStart__ctaImageContainer}>
          <img
            alt="App Example"
            className={css.greatStart__ctaImage}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1679333676/Hero_phone_mferv0.png"
          />
        </div>
      </div>
      {showStickyCta && !showConfettiPrimer && (
        <div className={css.stickyCTA}>
          <div className="text-center">
            <InfoButton
              pill
              className="phxxl"
              onClick={() => {
                goToNext()
              }}
            >
              Continue
            </InfoButton>
          </div>
        </div>
      )}
    </Slide>
  )
}

MobileAddItemsExperience.propTypes = {
  nextPath: PropTypes.string.isRequired,
}

export default MobileAddItemsExperience
